module.exports = new __parcel__URL__("ww-title-editorial-packages.75de9820.jpg").toString();